import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.styles.css";
import Profile from "../../assets/img/profile/profile.png";
import Image from "react-bootstrap/Image";
// import Button from "react-bootstrap/Button";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2 ">
                <Image
                  className="profile justify-content-end"
                  alt="profile"
                  src={Profile}
                  thumbnail
                  fluid
                />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                Hi there! I am <strong>&nbsp;Vaibhav Raj</strong>
                <br />
                I am currently learning full stack web development at Masai
                School. I am passionate about solving real-world problems and
                actively looking for opportunities in the field of web
                development and software engineering.
                <br />
                <br />
                <Col className="d-flex justify-content-center flex-wrap">
                  <div className="contact-info">
                    <div className="d-flex flex-column text-justify">
                      <p className="lead font-weight-bold">
                        <a
                          href="mailto:vaibhavraj524@gmail.com?body=Your message within Main Body"
                          className="text-dark"
                        >
                          <i className="far fa-envelope"></i>{" "}
                          vaibhavraj524@gmail.com
                        </a>
                      </p>
                      <p className="lead font-weight-bold">
                        <a href="tel:+919412350237" className="text-dark">
                          <i className="fas fa-phone"></i> +91 9412350237
                        </a>
                      </p>
                      <p className="lead font-weight-bold">
                        <i className="fas fa-map-marker-alt"></i> Bidhuna, U.P,
                        India
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
